import { Dispatch } from 'react';
import { PaginateList } from 'src/app/common/types';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { LmBatchFile, LmBatchFileListItem } from '../types/opm-pd-lm-types';

const opmPdLmEndpoint = 'opm-pd/lm/';

export type FetchLmBatchFilesParams = {
  page: number;
  limit: number;
  sort?: string;
};

type ApproveLmBatchFilesParams = {
  batchIds: string[];
};

type RejectLmBatchFilesParams = {
  batchIds: string[];
  reason: string;
};

type SendBackLmBatchFilesParams = {
  batchIds: string[];
  reason: string;
};

type FetchLmBatchFileParams = {
  id: string;
};

type ApproveLmBatchFilePoliciesParams = {
  id: string;
  policyIds: string[];
};

type RejectLmBatchFilePoliciesParams = {
  id: string;
  policyIds: string[];
  reason: string;
};

type SendBackLmBatchFilePoliciesParams = {
  id: string;
  policyIds: string[];
  reason: string;
};

export const fetchLmBatchFiles = async (
  params: FetchLmBatchFilesParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateList<LmBatchFileListItem>> => {
  const url = `${ADMIN_URL}/${opmPdLmEndpoint}batch-files`;
  return apiClient
    .get(url, {
      params: {
        ...params,
      },
    })
    .then((response) => {
      return response.data.data as PaginateList<LmBatchFileListItem>;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const approveLmBatchFiles = async (params: ApproveLmBatchFilesParams, dispatch?: Dispatch<any>) => {
  const url = `${ADMIN_URL}/${opmPdLmEndpoint}batch-files/approve`;
  return apiClient
    .post(url, params)
    .then((response) => {
      return response.data.data as PaginateList<LmBatchFileListItem>;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const rejectLmBatchFiles = async (params: RejectLmBatchFilesParams, dispatch?: Dispatch<any>) => {
  const url = `${ADMIN_URL}/${opmPdLmEndpoint}batch-files/reject`;
  return apiClient
    .post(url, params)
    .then((response) => {
      return response.data.data as PaginateList<LmBatchFileListItem>;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const sendBackLmBatchFiles = async (params: SendBackLmBatchFilesParams, dispatch?: Dispatch<any>) => {
  const url = `${ADMIN_URL}/${opmPdLmEndpoint}batch-files/sent-back`;
  return apiClient
    .post(url, params)
    .then((response) => {
      return response.data.data as PaginateList<LmBatchFileListItem>;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchLmBatchFile = async (params: FetchLmBatchFileParams, dispatch?: Dispatch<any>) => {
  const { id } = params;
  const url = `${ADMIN_URL}/${opmPdLmEndpoint}batch-files/${id}`;
  return apiClient
    .get(url)
    .then((response) => {
      return response.data.data as LmBatchFile;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const approveLmBatchFilePolicies = async (
  params: ApproveLmBatchFilePoliciesParams,
  dispatch?: Dispatch<any>,
) => {
  const { id, ...body } = params;
  const url = `${ADMIN_URL}/${opmPdLmEndpoint}batch-files/${id}/approve-policies`;
  return apiClient
    .post(url, body)
    .then((response) => {
      return response.data.data as PaginateList<LmBatchFileListItem>;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const rejectLmBatchFilePolicies = async (params: RejectLmBatchFilePoliciesParams, dispatch?: Dispatch<any>) => {
  const { id, ...body } = params;
  const url = `${ADMIN_URL}/${opmPdLmEndpoint}batch-files/${id}/reject-policies`;
  return apiClient
    .post(url, body)
    .then((response) => {
      return response.data.data as PaginateList<LmBatchFileListItem>;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const sendBackLmBatchFilePolicies = async (
  params: SendBackLmBatchFilePoliciesParams,
  dispatch?: Dispatch<any>,
) => {
  const { id, ...body } = params;
  const url = `${ADMIN_URL}/${opmPdLmEndpoint}batch-files/${id}/send-back-policies`;
  return apiClient
    .post(url, body)
    .then((response) => {
      return response.data.data as PaginateList<LmBatchFileListItem>;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const exportLmBatchFilePolicies = async (batchId: string, dispatch?: Dispatch<any>): Promise<Blob> => {
  return apiClient
    .get<Blob>(`${ADMIN_URL}/${opmPdLmEndpoint}batch-files/${batchId}/export-policies`, {
      responseType: 'blob',
    })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
